module.exports = __webpack_public_path__ + "static/media/Piercing-ear-helix.349fbe78.png";